import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {
  FrontMouseEvent,
  Handler,
  HandlerOf,
} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {UserTheme, useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {StyledSearchBarRightButton} from '../../../../common/searchBar/searchBar';

/*
 * Props.
 */

interface InboxesSearchQueryBuilderButtonProps {
  hasFocus: boolean;
  isOpen: boolean;
  onMouseDown: HandlerOf<FrontMouseEvent<HTMLElement>>;
  onClick: Handler;
}

/*
 * Styles.
 */

export interface InboxesSearchBarButtonStyleProps {
  $hasFocus: boolean;
  $isOpen: boolean;
}

const StyledQueryBuilderButton = styled(StyledSearchBarRightButton)<InboxesSearchBarButtonStyleProps>`
  ${(p) => computeInboxesSearchBarButtonBackgroundColor(p.$hasFocus, p.$isOpen)}
`;

/*
 * Styles helpers.
 */

export const computeInboxesSearchBarButtonBackgroundColor = (hasFocus: boolean, isOpen: boolean) => {
  const findBackgroundColor = (theme: UserTheme) => (hasFocus ? theme.greys.shade30 : theme.alphas.black40);

  return isOpen
    ? css`
        background-color: ${(p) => findBackgroundColor(p.theme)};
      `
    : css`
        &:hover {
          background-color: ${(p) => findBackgroundColor(p.theme)};
        }
      `;
};

/*
 * Component.
 */

export const InboxesSearchQueryBuilderButton: FC<InboxesSearchQueryBuilderButtonProps> = (props) => {
  const theme = useUserTheme();
  const {hasFocus, isOpen, onMouseDown, onClick} = props;

  return (
    <StyledQueryBuilderButton
      onMouseDown={onMouseDown}
      onClick={onClick}
      interactionId="search-query-builder-button"
      $hasFocus={hasFocus}
      $isOpen={isOpen}
    >
      <Icon
        name="filtersSmall"
        color={hasFocus ? theme.greys.shade70 : theme.searchBar.text}
        hoverColor={hasFocus ? theme.greys.shade80 : theme.searchBar.textHover}
      />
    </StyledQueryBuilderButton>
  );
};
